import React, { useEffect, useState } from 'react'
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Label } from '../../../components/Input';
import Layout from '../../../components/layouts/Layout'
import { Required } from '../../../components/RegEx/ValidationMessage';
import timeZone from '../../../dbJson/timezones.json';
import UploadFile from '../../../hook/UploadFile';
import { eventCreateReset, eventInfo, eventIdSet } from './slice/createEventSlice';
import NewFormWizard from '../../../components/formWizard/NewFormWizard';
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars';
import moment from 'moment'
import http from '../../../config/BaseUrl';
import { LoadingSpinner } from '../../../components/Loader/Loader';

const EventInfo = () => {

    const history = useHistory();
    const dispatch = useDispatch()
    const { event_info, eventId } = useSelector(state => state.createEvent)
    // const [eventId, setEventId] = useState(null)
    const [startDateDefault, setStartDateDefault] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDateDefault, setEndDateDefault] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [time_zone, setTimeZone] = useState(null)
    const [lifeTime, setLifeTime] = useState(false)
    const [event_image, setEventImage] = useState(null)
    const [loading, setLoading] = useState(false)

    const htmlAttributes = { placeholder: "Select a date and time" };

    // useEffect(() => {
    //     // dispatch(eventCreateReset())
    //     localStorage.removeItem("persist:root")
    // }, [])


    const { register, handleSubmit, setError, formState: { errors }, clearErrors } = useForm({
        mode: "onChange",
        reValidateMode: "all",
        defaultValues: {
            event_name: event_info.event_name,
            event_start_date: event_info.event_start_date,
            event_details: event_info.event_details,
            event_end_date: event_info.event_end_date,
            event_venue_name: event_info.event_venue_name,
            event_time_zone: event_info.event_time_zone,
        }
    });

    useEffect(() => {
        if (event_info) {
            let item = event_info
            if (Object.keys(item).length > 0) {
                setStartDate(item.event_start_date)
                setStartDateDefault(moment(item.event_start_date).format('DD-MM-YYYY HH:mm'))
                if (item.life_time) {
                    setLifeTime(true)
                }
                else{
                    setEndDate(item.event_end_date)
                    setEndDateDefault(moment(item.event_end_date).format('DD-MM-YYYY HH:mm'))
                }
                setTimeZone(item.event_time_zone)
                setFileURL(item.fileURL)
            }
        }
    }, [])

    const dateStartTimeConverter = (value) => {
        setStartDate(moment(value).format('YYYY-MM-DD HH:mm'))
        setStartDateDefault(value)
        if (value) {
            clearErrors('event_start_date')
        }
    }
    const dateEndTimeConverter = (value) => {
        setEndDate(moment(value).format('YYYY-MM-DD HH:mm'))
        setEndDateDefault(value)
        if (value) {
            clearErrors('event_end_date')
        }
    }

    // custom hook
    const { fileURL, onChangeFile, setFileURL } = UploadFile()

    const handelInfo = (data) => {
        if (lifeTime) {
            if (!startDate || startDate === 'Invalid date') {
                setError("event_start_date", {
                  type: "manual",
                  message: "Event start date is required",
                });
                setTimeout(()=>{
                  clearErrors(['event_start_date'])
                }, 3000)
            }
            else {  
                submitFormData(data)        
            } 
        }
        else{
            if (!startDate || !endDate) {
                if (!startDate || startDate === 'Invalid date') {
                    setError("event_start_date", {
                        type: "manual",
                        message: "Event start date is required",
                    });
                }
                if (!endDate || endDate === 'Invalid date') {
                    setError("event_end_date", {
                        type: "manual",
                        message: "Event end date is required",
                    });
                }

                setTimeout(()=>{
                    clearErrors(['event_start_date', 'event_end_date'])
                }, 3000)
    
            } else {
                submitFormData(data)
            }
        }
    }

    const submitFormData = async (data) => {
        let startDt = new Date(startDateDefault);
        let endDt = new Date(endDateDefault);
        let hours = Math.round(endDt - startDt) / 36e5;

        if (lifeTime) {
            let eventEndDate = moment().add(200, 'y').format('YYYY-MM-DD HH:mm')

            dispatch(eventInfo({ ...data, fileURL, event_start_date: startDate, event_end_date: '', life_time: lifeTime }));
            setLoading(true)
            http.post("event-info", { ...data, fileURL, event_start_date: startDate, event_end_date: eventEndDate, eventId, life_time: lifeTime ? 1 : 0 })
                .then((res) => {
                    if (res.data.status === true) {
                        let event_id = res.data.event.id
                        dispatch(eventIdSet(event_id))
                        history.push('/event/feature', { eventId: event_id })
                        setLoading(false)
                    }
                })
                .catch(err => {
                    console.log(err.response.message)
                    setLoading(false)
                });
        }
        else if (hours <= 48 && hours > 0) {
            dispatch(eventInfo({ ...data, fileURL, event_start_date: startDate, event_end_date: endDate, life_time: lifeTime }));
            setLoading(true)
            http.post("event-info", { ...data, fileURL, event_start_date: startDate, event_end_date: endDate, eventId, life_time: lifeTime ? 1 : 0 })
                .then((res) => {
                    console.log('hi')
                    if (res.data.status === true) {
                        let event_id = res.data.event.id
                        dispatch(eventIdSet(event_id))
                        history.push('/event/feature', { eventId: event_id })
                        setLoading(false)
                    }
                })
                .catch(err => {
                    console.log(err.response.message)
                    setLoading(false)
                });

        } else {
            let name = { event_end_date: ["event_end_date"] };
            let nameArr = [["Please select date & time below 48 hour"]];
            const errorNames = Object.keys(name);
            const errorMessages = Object.values(nameArr);
            errorNames.forEach((err, indx) => {
                setError(err, { type: 'required', message: errorMessages[indx][0] })
            })

            setTimeout(() => {
                clearErrors(errorNames)
            }, 3000)

        }
    }

    const checkLifeTime = (e) => {
        setLifeTime(e.target.checked)
    }

    return (
        <Layout>
            <NewFormWizard />
            <form onSubmit={handleSubmit(handelInfo)}>
                <section className="mt-4">
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="px-2 card">
                                <div className="py-5 text-center border-bottom">
                                    <h4 className="text-primary display-4 event-form-title">Event Information</h4>
                                    <span className="text-secondary">Fill in the blanks</span>
                                </div>
                                <div className="p-4 card-body">

                                    <div className="row">
                                        <div className="form-group col-md-12">
                                            <label htmFor="event_name" >Event Name<span className="pl-1 text-danger font-size-14">*</span></label>
                                            <input
                                                type="text"
                                                name="event_name"
                                                placeholder="Event name"
                                                className={`form-control mb-2 ${errors.event_name && 'is-invalid'}`}
                                                {...register("event_name", { required: Required })}
                                            />
                                            <span className="text-danger font-size-14">{errors.event_name && errors.event_name.message}</span>
                                        </div>

                                        <div className="form-group col-md-6">
                                            <label>Event Start Date & Time</label>
                                            <DateTimePickerComponent
                                                format="dd-MM-yyyy hh:mm"
                                                id="datetimepicker"
                                                htmlAttributes={htmlAttributes}
                                                cssClass="date-time-input customClass"
                                                value={startDateDefault}
                                                min={startDateDefault || new Date()}
                                                change={e => { dateStartTimeConverter(e.value) }}
                                            />
                                            <span className="text-danger font-size-14">{errors.event_start_date && errors.event_start_date.message}</span>
                                        </div>

                                        <div className="form-group col-md-6">
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <label>Event Finish Date & Time</label>
                                                <div className="custom-control custom-checkbox life-time-check mb-0">
                                                    <input 
                                                        type="checkbox" 
                                                        className="custom-control-input" 
                                                        id="customCheck1"
                                                        checked={lifeTime ? "checked" : ""}
                                                        onChange={checkLifeTime} 
                                                    />
                                                    <label className="custom-control-label" htmlFor="customCheck1">Ongoing event</label>
                                                </div>
                                            </div>
                                            <DateTimePickerComponent
                                                format="dd-MM-yyyy hh:mm"
                                                id="datetimepicker"
                                                htmlAttributes={htmlAttributes}
                                                cssClass="date-time-input customClass"
                                                value={endDateDefault}
                                                min={startDateDefault || new Date()}
                                                disabled={lifeTime}
                                                enabled={!lifeTime}
                                                change={e => { dateEndTimeConverter(e.value) }}
                                            />
                                            <span className="text-danger font-size-14">{errors.event_end_date && errors.event_end_date.message}</span>

                                        </div>

                                        <div className="form-group col-md-6">

                                            <label htmFor="event_details" >Subtitle<span className="pl-1 text-danger font-size-14"></span></label>
                                            <input
                                                type="text"
                                                name="event_details"
                                                placeholder=""
                                                className={`form-control mb-2 ${errors.event_details && 'is-invalid'}`}
                                                {...register("event_details", { required: Required })}
                                            />
                                            <span className="text-danger font-size-14">{errors.event_details && errors.event_details.message}</span>

                                        </div>

                                        <div className="form-group col-md-6">
                                            <label htmFor="event_venue_name" >Venue Name<span className="pl-1 text-danger font-size-14"></span></label>
                                            <input
                                                type="text"
                                                name="event_venue_name"
                                                placeholder=""
                                                className={`form-control mb-2 ${errors.event_venue_name && 'is-invalid'}`}
                                                {...register("event_venue_name", { required: Required })}
                                            />
                                            <span className="text-danger font-size-14">{errors.event_venue_name && errors.event_venue_name.message}</span>

                                        </div>

                                        <div className="form-group col-md-6">
                                            <Label htmlFor="eventTimeZone">Timezone</Label>
                                            <select
                                                name="event_time_zone"
                                                id="eventTimeZone"
                                                className={classNames("form-control", { "is-invalid": errors.event_time_zone })}
                                                {...register("event_time_zone", {
                                                    required: "This field is required"
                                                })}
                                            >
                                                <option value="">Select time zone</option>
                                                {timeZone && timeZone.map((res, index) => (
                                                    <option key={index} value={res.text} selected={event_info.event_time_zone || time_zone === res.text ? 'selected' : ''}>{res.text}</option>
                                                ))}
                                            </select>
                                            <p className="mt-2 text-danger">{errors.event_time_zone && errors.event_time_zone.message}</p>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Event Image</label>
                                                <div className="mb-3 input-group">
                                                    <div className="custom-file">
                                                        <input
                                                            type="file"
                                                            className="custom-file-input"
                                                            id="inputGroupFile01"
                                                            aria-describedby="inputGroupFileAddon01"
                                                            onChange={onChangeFile}
                                                        />
                                                        <label className="custom-file-label" forHtml="inputGroupFile01">
                                                            {
                                                                fileURL ?
                                                                    <img src={fileURL} className="img-fluid" alt="event" style={{ width: '35px', height: '20px' }} />
                                                                    : 'Choose file'
                                                            }

                                                        </label>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            {loading ?
                                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                </button>)
                                : <button type="submit" className="float-right px-5 btn btn-primary radius-10">Next</button>
                            }
                        </div>
                    </div>
                </section>
            </form>
        </Layout>
    )
}

export default EventInfo
